import React, { useEffect, useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonRadioGroup,
    IonRadio,
    IonItem,
    IonLabel,
    IonButton,
    IonText,
    IonImg
} from '@ionic/react';

interface AnalogyPart {
    type: string;
    value: string;
}

interface AnalogyQuestion {
    part1: AnalogyPart;
    part2: AnalogyPart;
    part3: AnalogyPart;
    options: AnalogyPart[];
    correct: string; // Must match value of correct option
}


const renderPart = (part: AnalogyPart) => {
    return part.type === "image" ? (
        <IonImg src={`${process.env.REACT_APP_API_URL ?? ""}${part.value ?? "question-mark.png"}`} style={{ maxWidth: "60px", display: 'inline-block', margin: '0 8px' }} />
    ) : (
        <span style={{ fontWeight: 500 }}>{part.value}</span>
    );
};

const AnalogyWithImages: React.FC = () => {
    const [questions, setQuestions] = useState<AnalogyQuestion[]>([]);
    const [currentQ, setCurrentQ] = useState<AnalogyQuestion | null>(null)
    const [selected, setSelected] = useState<string | null>(null);
    const [showAnswer, setShowAnswer] = useState(false);
    const [showImage, setShowImage] = useState(false);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const createNewQuestion = async () => {

        let data: AnalogyQuestion[] = [];

        if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
            const response = await fetch(process.env.REACT_APP_API_URL + 'Analogy.json');
            data = await response.json();
        } else {
            const module = await import('../../datas/Analogy.json');
            data = module.default;
        }

        const shuffledQuestions = shuffleArray(data);
        setQuestions(shuffledQuestions);
        setCurrentQ(shuffledQuestions[0]);
        setSelected(null);
    }

    const getNextQuestion = () => {
        const remaining = questions.filter(q => q !== currentQ);
        if (remaining.length > 0) {
            return remaining[Math.floor(Math.random() * remaining.length)];
        }
        return currentQ; // fallback
    };

    const handleSelect = (value: string) => {
        if (!currentQ) return;
        setSelected(value);
        if (value === currentQ.correct) {
            setShowImage(true);
            setTimeout(() => {
                setShowImage(false);
                const next = getNextQuestion();
                setCurrentQ(next);
                setSelected(null);
            }, 3000);
        }
    };

    useEffect(() => {
        createNewQuestion();
        document.title =
            "Mamas Guidance - OLYMPIAD - Logical Reasoning - Analogy";
    }, []);

    if (!currentQ) return <p>Loading...</p>;

    return (
        <>
            {!showImage ? (
                <div className="contentPart  fillPreposition additionWord rankingTest">
                    <div>
                        <div><IonText className='analogyText'>{renderPart(currentQ.part1)} : {renderPart(currentQ.part2)} :: {renderPart(currentQ.part3)} : ?</IonText></div>
                        <IonRadioGroup className="mb-5 displayFlex" value={selected} onIonChange={e => handleSelect(e.detail.value)}>
                            {currentQ.options.map((option, index) => (
                                <IonItem className={`mygrid grid-item ${selected === option.value
                                    ? option.value === currentQ.correct
                                        ? "correct"
                                        : "errorOptions"
                                    : ""
                                    }`} key={index}>
                                    <IonLabel>
                                        {option.type === "image" ? (
                                            <IonImg src={option.value} style={{ maxWidth: "80px" }} />
                                        ) : (
                                            option.value
                                        )}
                                    </IonLabel>
                                    <IonRadio slot="start" value={option.value} disabled={showAnswer} />
                                </IonItem>
                            ))}
                        </IonRadioGroup>
                    </div>
                </div>

            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK ?? ""}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default AnalogyWithImages;
